function setRem() {
	var screenWidth = document.documentElement.getBoundingClientRect().width;
	var width = screenWidth > 640 ? 640 : screenWidth;
	document.documentElement.style.fontSize = 100 * width / 375 + 'px';
};
var resize = 'orientationchange' in window ? 'orientationchange' : 'resize';
window.addEventListener(resize, setRem);
setRem();


// WEBPACK FOOTER //
// ./src/js/setRem.js